import { NumberInput } from 'components/NumberInput';
import * as S from 'containers/PropertyPanel/PropertyPanel.styles';
import PropertyPanelAccordion from 'containers/PropertyPanel/components/PropertyPanelAccordion';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getMetricType } from 'store/settings/selectors';
import { useEditFlowProperties } from '../useEditFlowProperties';
import { CONVERSIONS, getMetricUnit } from 'util/conversions';
import { getPsdFromFraction } from '../util';
import type { FlowPropertiesProps } from '../withFlowProperties';
import { withFlowProperties } from '../withFlowProperties';

type Props = FlowPropertiesProps;

const Fractions = ({ id, flowProperties, activeUnit }: Props) => {
  const metricType = useSelector(getMetricType);
  const { currentPort, setValue } = useEditFlowProperties(
    id,
    activeUnit,
    flowProperties,
  );

  const [fractionDiffPercent, setFractionDiffPercent] = useState<
    number | undefined
  >();

  const fractionDiffMass =
    fractionDiffPercent && currentPort?.outputFlow?.totalMass
      ? Math.round(
          100 *
            (fractionDiffPercent / 100) *
            currentPort?.outputFlow?.totalMass,
        ) / 100
      : undefined;

  const { fractionOne, fractionTwo } = flowProperties;

  /* Calc fraction diff when fraction 1 or 2 changes */
  useEffect(() => {
    const psdFractionOne =
      getPsdFromFraction(fractionOne, currentPort?.outputFlow, metricType) ?? 0;
    const psdFractionTwo =
      getPsdFromFraction(fractionTwo, currentPort?.outputFlow, metricType) ??
      100;

    setFractionDiffPercent(psdFractionTwo - psdFractionOne);
  }, [fractionOne, fractionTwo, currentPort, metricType]);

  return (
    <PropertyPanelAccordion title='Fractions'>
      <S.GridLayout
        layout={[
          ['3', '3'],
          ['3', '3'],
        ]}
      >
        <NumberInput
          value={fractionOne}
          setValue={(val) => setValue('fractionOne', val)}
          label={`[${getMetricUnit(metricType, CONVERSIONS.MILLIMETER)}]`}
          marginRight={16}
          optional
        />
        <NumberInput
          value={fractionTwo}
          setValue={(val) => setValue('fractionTwo', val)}
          label={`[${getMetricUnit(metricType, CONVERSIONS.MILLIMETER)}]`}
          optional
        />
        <NumberInput
          value={fractionDiffPercent}
          setValue={() => {}}
          label={`[%]`}
          marginRight={16}
          disabled
          optional
        />
        {fractionDiffMass !== undefined && (
          <NumberInput
            value={fractionDiffMass}
            conversionType={CONVERSIONS.CAPACITY}
            setValue={() => {}}
            label={`[${getMetricUnit(metricType, CONVERSIONS.CAPACITY)}]`}
            disabled
            optional
          />
        )}
      </S.GridLayout>
    </PropertyPanelAccordion>
  );
};

export default withFlowProperties(Fractions);
